module.exports = __webpack_public_path__ + "static/media/startpage2026_768.870132c2.jpg";